import { maestroApiCall } from '@michelin/central-provider';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';

export const useDealerCanCreateVehicle = (fleetId: string, dealerId: string) => {
  return useQuery<boolean | null>(
    ['useDealerCanCreateVehicle', fleetId, dealerId],
    () => {
      if (!fleetId || !dealerId) return null;
      return maestroApiCall({
        method: 'GET',
        endpoint: `can-create-vehicle/${fleetId}/${dealerId}`,
        baseURL,
      });
    },
    {
      cacheTime: 3600,
    },
  );
};

export const useFleetCanCreateVehicle = (fleetId: string) => {
  return useQuery<{ canCreate: boolean; canUpdate: boolean } | null>(
    ['useFleetCanCreateVehicle', fleetId],
    () => {
      if (!fleetId) return null;
      return maestroApiCall({
        method: 'GET',
        endpoint: `can-fleet-create-vehicle/${fleetId}`,
        baseURL,
      });
    },
    {
      cacheTime: 3600,
    },
  );
};
